import { EnvironmentEnum } from '@app/core/helpers/enums/enums';
import { environment } from '@environment/environment';
import { openDB, IDBPDatabase, deleteDB } from 'idb';
import { LoggerService } from '../logger.service';
import { MyDB } from './schema/mydb.schema';

export abstract class BaseRepository {


    db: IDBPDatabase<MyDB>
    readonly dbName = ('recDb' as never)
    readonly recFileTbl = ('recFile' as never)
    readonly recChunkTbl = ('recChunk' as never)
    readonly appDataTbl = ('appData' as never)


    constructor(
        protected readonly logger: LoggerService
    ) {
        this.init();
    }

    /**
     * initiate index db
     */
    async init() {
        try {
            if (!this.db) {
                let _this = this;
                this.db = await openDB<MyDB>(this.dbName, 2, {
                    upgrade(db) {
                        const fileStore = db.createObjectStore(_this.recFileTbl, {
                            keyPath: 'name'
                        });
                        fileStore.createIndex('by-name', 'name', { unique: true });



                        const chunkStore = db.createObjectStore(_this.recChunkTbl, {
                            keyPath: ['recFileId', 'partGroupNo', 'part'],
                        });
                        chunkStore.createIndex('by-keypath-chunk', ['recFileId', "partGroupNo", 'part'], { unique: true });


                        // const appStore = db.createObjectStore(_this.appDataTbl, {
                        //     keyPath: 'id'
                        // });

                        // appStore.createIndex('by-id', 'id', { unique: true });

                        _this.logger.log('DB is created or upgraded.')
                    },
                });
            }
            try {
                environment.env !== EnvironmentEnum.production && (window['dbtest'] = this.db);
            } catch { }
        } catch (error) {
            this.logger.error('init db', error);
            let message = error.message as string
            if (message.includes('is less than the existing version')) {
                await deleteDB(this.dbName, {
                    blocked() {
                        console.log('blocked')
                    },
                });
                this.init();
            }
        }
    }


}